<template>
  <el-card v-if="!isBlank" class=""
           :body-style="{padding: '20px',height: '100%',boxSizing: 'border-box', textAlign: 'left'}">
    <router-view></router-view>
  </el-card>
  <router-view v-else></router-view>
</template>

<script>
export default {
  name: "index",
  computed: {
    isBlank() {
      let isBlank = this.$route.meta && this.$route.meta.isBlank === true;
      return isBlank;
    },
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style>
.el-card {
  height: 100%;
}

.search-form {
  text-align: left;
  margin-top: 15px;
  padding: 0 8px;
}
.btn_box {
  text-align: right;
  margin-top: 8px;
  height: 40px;
}

.flex-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.flex-item:nth-child(1), .flex-item:nth-child(2), .flex-item:nth-child(4) {
  flex-grow: 0;
  flex-shrink: 0;
}

.flex-item:nth-child(3) {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}

.pagination {
  margin-top: 8px;
}
</style>